import { createReducer } from "redux-starter-kit";
import { appSetTitleAction } from "../actions/appTitles";

const INIT_STATE = {};

const appTitles = createReducer(INIT_STATE, {
  [appSetTitleAction]: (state, action) => {
    state[action.payload.title.id] = action.payload.title;
  }
});

export default appTitles;
